<template>
    <div>
        <ul class="calamity-chart-list" v-if="safetyDetailInfo.safetyCategory === '재난'">
            <li :class="{'on': curStateCd >= 0}">
                <p :class="['title', {'active': curStateCd === 0}]">출동지령</p>
                <p class="time" v-if="historyMap['S_0']">{{ historyMap['S_0'] ? historyMap['S_0'].recDateHm : '-' }}</p>
            </li>
            <li :class="{'on': curStateCd >= 10}">
                <p :class="['title', {'active': curStateCd === 10}]">출동중</p>
                <p class="time" v-if="historyMap['S_10']">{{ historyMap['S_10'] ? historyMap['S_10'].dispatchHm : '-' }}</p>
            </li>
            <li :class="{'on': curStateCd >= 20}">
                <p :class="['title', {'active': curStateCd === 20}]">현장도착</p>
                <p class="time" v-if="historyMap['S_20']">{{ historyMap['S_20'] ? historyMap['S_20'].arrivalHm : '-' }}</p>
            </li>
            <li :class="{'on': curStateCd >= 30}">
                <p :class="['title', {'active': curStateCd === 30}]">활동개시</p>
                <p class="time" v-if="historyMap['S_30']">{{ historyMap['S_30'] ? historyMap['S_30'].recDateHm : '-' }}</p>
            </li>
            <li :class="{'on': curStateCd >= 50}">
                <p :class="['title', {'active': curStateCd === 50}]">조치완료</p>
                <p class="time" v-if="historyMap['S_50']">{{ historyMap['S_50'] ? historyMap['S_50'].recDateHm : '-' }}</p>
            </li>
            <li :class="{'on': curStateCd >= 60}">
                <p :class="['title', {'active': curStateCd === 60}]">귀소중</p>
                <p class="time" v-if="historyMap['S_60']">{{ historyMap['S_60'] ? historyMap['S_60'].recDateHm : '-' }}</p>
            </li>
            <li :class="{'on': curStateCd == 100}">
                <p :class="['title', {'active': curStateCd === 100}]">상황종료</p>
                <p class="time" v-if="historyMap['S_100']">{{ historyMap['S_100'] ? historyMap['S_100'].closeHm : '-' }}</p>
            </li>
        </ul>
        <ul class="calamity-chart-list" v-else-if="safetyDetailInfo.safetyCategory === '화재'">
            <li :class="{'on': curStateCd >= 0}">
                <p :class="['title', {'active': curStateCd === 0}]">출동지령</p>
                <p class="time" v-if="historyMap['S_0']">{{ historyMap['S_0'] ? historyMap['S_0'].recDateHm : '-' }}</p>
            </li>
            <li :class="{'on': curStateCd >= 10}">
                <p :class="['title', {'active': curStateCd === 10}]">출동중</p>
                <p class="time" v-if="historyMap['S_10']">{{ historyMap['S_10'] ? historyMap['S_10'].dispatchHm : '-' }}</p>
            </li>
            <li :class="{'on': curStateCd >= 20}">
                <p :class="['title', {'active': curStateCd === 20}]">현장도착</p>
                <p class="time" v-if="historyMap['Sm_20']">{{ historyMap['S_20'] ? historyMap['S_20'].arrivalHm : '-' }}</p>
            </li>
            <li :class="{'on': curStateCd >= 30}">
                <p :class="['title', {'active': curStateCd === 30}]">활동개시</p>
                <p class="time" v-if="historyMap['S_30']">{{ historyMap['S_30'] ? historyMap['S_30'].recDateHm : '-' }}</p>
            </li>
            <li :class="{'on': curStateCd >= 40}">
                <p :class="['title', {'active': curStateCd === 40}]">초진</p>
                <p class="time" v-if="historyMap['S_40']">{{ historyMap['S_40'] ? historyMap['S_40'].recDateHm : '-' }}</p>
            </li>
            <li :class="{'on': curStateCd >= 50}">
                <p :class="['title', {'active': curStateCd === 50}]">완진</p>
                <p class="time" v-if="historyMap['S_50']">{{ historyMap['S_50'] ? historyMap['S_50'].recDateHm : '-' }}</p>
            </li>
            <li :class="{'on': curStateCd == 100}">
                <p :class="['title', {'active': curStateCd === 100}]">상황종결</p>
                <p class="time" v-if="historyMap['S_100']">{{ historyMap['S_100'] ? historyMap['S_100'].closeHm : '-' }}</p>
            </li>
        </ul>
    </div>
</template>

<script>
import { $WC } from '@/conf/common.const.js';

export default {
    name: 'SafetyInfoHistoryChart',
    data: function() {
        return {
            historyMap: {},
            isTransfer: false,
            curState: '',
            curStateCd: -1,
            safetyHistoryList: [],
            lastHistory: {},
        };
    },
    props: {
        safetyDetailInfo: {
            type: Object,
            required: true
        }
    },
    watch: {
        safetyDetailInfo: {
            immediate: false,
            handler: function(newVal, oldVal) {
                this.safetyHistoryList = newVal.safetyHistoryList;
                
                let historyList = this.safetyHistoryList;
                let historyMap = {};
                let lastHistory = {};
                
                if(typeof historyList !== $WC.UNDEF) {
                    for(let i = 0; i < historyList.length; i++) {
                        let historyStatuCd = historyList[i]['processStateCd'];
                        historyMap['S_' + historyStatuCd] = historyList[i];
                        
                        if(historyList[i].processState === '이송중') {
                            this.isTransfer = true;
                        }
                        
                        if(i == (historyList.length - 1)) {
                            lastHistory = historyList[i];
                        }
                    }
                }
                
                this.historyMap = historyMap;
                
                this.curState = '' || lastHistory['processState'];
                this.curStateCd = '' || lastHistory['processStateCd'];
            }
        }
    },
}
</script>